import { Fragment, ReactNode } from 'react';
import classnames from 'classnames';
import { EmptyTripInfo } from '@lp/features/RoutePlanner/components/GroundTrip';
import { Uuid } from '@/api/types';

type TripInfoBlockContent = {
  id: Uuid;
  item: ReactNode;
};

type TripInfoBlockProps = {
  title: string;
  emptyMessage: string;
  listType?: 'horizontal' | 'vertical';
  content: TripInfoBlockContent[];
};

export const TripInfoBlock = ({ title, emptyMessage, content, listType = 'vertical' }: TripInfoBlockProps) => {
  return (
    <div className="flex flex-col gap-3">
      <span className="text-m-sb text-base-5">{title}</span>
      {content.length ? (
        <div className={classnames('flex gap-4 items-stretch', { 'flex-col': listType === 'vertical' })}>
          {content.map((i) => (
            <Fragment key={i.id}>{i.item}</Fragment>
          ))}
        </div>
      ) : (
        <EmptyTripInfo message={emptyMessage} />
      )}
    </div>
  );
};
